import { Formik } from "formik";
import { Form } from "react-router-dom";
import * as Yup from "yup";
import InputFormik from "../../../../common/components/form/InputFormik";
import ButtonWithLoader from "../../../../common/components/ui/loading/ButtonLoading";
import { maskPhone } from '../../../../common/helpers/mask.helpers';
import ComboBoxFormik from "../../../../common/components/form/ComboBoxFormik";

const validationSchema = Yup.object().shape({
  companyId: Yup.string()
    .notOneOf(['-'], 'Cidade inválido')
    .required('Cidade é obrigatório'),
  name: Yup.string()
    .required('Nome/Razão Social é obrigatório')
    .test(
      'full-name',
      'Deve incluir pelo menos um nome e um sobrenome',
      value => {
        if (!value) {
          return false;
        }
        const names = value.split(' ');
        return names.length >= 2;
      }
    ),
  whatsapp: Yup.string()
    .required('Whatsapp é obrigatório'),
  email: Yup.string()
    .email('E-mail inválido')
    .required('E-mail é obrigatório'),
});

type FormPropsCreateIndicator = {
  onSubmit: (values: { name: string }) => void;
}

export default function FormRegisterIndicator(props: FormPropsCreateIndicator) {
  const initialValues = { name: '' };

  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);
    await props.onSubmit(values);
    setSubmitting(false);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, handleSubmit }) => {
        return (
          <Form className="text-xs">
            <ComboBoxFormik
              label="Selecione a cidade onde deseja indicar:"
              name="companyId"
              options={[
                { value: "", label: "-" },
                { value: "TODOS", label: "Todas" },
                { value: "ANAPOLIS", label: "Anápolis" },
                { value: "BRASILIA", label: "Brasília" },
                { value: "CAMPO GRANDE", label: "Campo Grande" },
                { value: "CUIABA", label: "Cuiabá" },
                { value: "GOIANIA", label: "Goiânia" },
                { value: "SENADOR CANEDO", label: "Senador Canedo" },
                { value: "TERESINA", label: "Teresina" },
                { value: "RIO VERDE", label: "Rio Verde" },
                { value: "VALPARAISO DE GOIAS", label: "Valparaíso de Goiás" },
                { value: "AGUAS LINDAS DE GOIAS", label: "Águas Lindas de Goiás" },
                { value: "RECIFE", label: "Recife" },
                { value: "SAO LUIS", label: "São Luís" },
                { value: "CAMPINAS", label: "Campinas" },
                { value: "UBERLANDIA", label: "Uberlandia" }
              ]}
              required={true}
            />

            <InputFormik
              label="Nome/Razão Social completo:"
              name="name"
              className="mb-1 text-xs"
              required={true}
            />

            <InputFormik
              label="WhatsApp:"
              name='whatsapp'
              mask={maskPhone}
              className="mb-1"
              required={true}
            />

            <InputFormik
              label="E-mail:"
              name='email'
              className="w-full"
              required={true}
            />

            {/* Botão de Envio */}
            <div className="flex justify-end">
              <ButtonWithLoader isLoading={isSubmitting} onClick={handleSubmit}> Enviar </ButtonWithLoader>
            </div>
          </Form>
        )
      }}

    </Formik>
  );
}


